import { render } from "./Content.vue?vue&type=template&id=3c037920&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=3c037920&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c037920"

export default script